import Cricket from "./cricket";

class Game extends Cricket {

  WITH_SCORE = true

  constructor(store, default_game, urls = window.URLS) {
    super(store, default_game, urls, 'cricket_american')
  }

  getWinnerNumberByLeg(leg) {
    const win_player_1 = this.sectors.every((sector) => this.completeSector(leg, sector, 0))
    const win_player_2 = this.sectors.every((sector) => this.completeSector(leg, sector, 1))

    const [score_1, score_2] = this.calculateScore(leg)
    if (win_player_1 && score_1 >= score_2) {
      return 1
    }
    if (win_player_2 && score_2 >= score_1) {
      return 2
    }
  }
}

export default Game